import API from './config';

export function publish(newspaperId: string, editionId: string, params: {
  visibility?: 'public' | 'private' | 'password';
  password?: string;
  cover_title?: string;
  cover_subtitle?: string;
  editor_picks?: string[];
  excluded_story_ids?: string[];
  story_order?: string[];
}) {
  return API.post(`/newspapers/${newspaperId}/editions/${editionId}/publish`, params);
}

export function update(newspaperId: string, editionId: string, params: {
  visibility?: string;
  password?: string;
  cover_title?: string;
  cover_subtitle?: string;
  editor_picks?: string[];
  excluded_story_ids?: string[];
  story_order?: string[];
}) {
  return API.patch(`/newspapers/${newspaperId}/editions/${editionId}/publish`, params);
}

export function unpublish(newspaperId: string, editionId: string) {
  return API.delete(`/newspapers/${newspaperId}/editions/${editionId}/publish`);
}

export interface ReaderStory {
  id: string;
  student_name: string;
  template_type: string;
  template_label: string;
  title: string;
  content: {
    blocks: { type: string; text: string }[];
    images: { url: string; caption: string }[];
  };
  is_editor_pick: boolean;
  teaser?: string;
}

export interface ReaderData {
  newspaper_name: string;
  edition_name: string;
  published_at: string;
  slug: string;
  ai_headline?: string;
  ai_editors_note?: string;
  editor_picks: string[];
  stories: ReaderStory[];
  story_count: number;
  view_count: number;
}

export function read(slug: string) {
  return API.get<{ data: ReaderData } | { requires_password: boolean; newspaper_name: string; edition_name: string }>(`/read/${slug}`);
}

export function verifyPassword(slug: string, password: string) {
  return API.post<{ data: ReaderData }>(`/read/${slug}/verify`, { password });
}
